import { useT } from "@transifex/react";
import SmallTextToggle from "../../../../basic/smallTextToggle/SmallTextToggle";

interface PDFSettingsTopBottomToggleProps {
    isTop: boolean;
    togglePosition: () => void;
    disabled?: boolean;
}

const PDFSettingsTopBottomToggle = (props: PDFSettingsTopBottomToggleProps) => {
    const t = useT();

    const t_top = t("top", { _tags: "PDFConfiguration" });
    const t_bottom = t("bottom", { _tags: "PDFConfiguration" });

    return (
        <SmallTextToggle
            isLeft={props.isTop}
            togglePosition={props.togglePosition}
            leftText={t_top}
            rightText={t_bottom}
            disabled={props.disabled}
            leftIconName={"arrow-up"}
            rightIconName={"arrow-down"}
        />
    );
};

export default PDFSettingsTopBottomToggle;
